module.exports = __webpack_public_path__ + "media/images/footer_page/claims/step2-77fcc23030c875fb5de0c46bdc206139.svg";